import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Heading, Button } from '@aws-amplify/ui-react';
import { useCareGiverPutMutation } from './api/useCareGiversMutation';
import { useCareGiversByPatientIdQuery } from './api/useCareGiversQuery';
import CareGiverViewTable from './CareGiverViewTable';
import { useUserQuery } from '../common/useUserQuery';

export default function CareGiversPage() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();

  const { data, isFetching } = useCareGiversByPatientIdQuery(userQueryData?.patientUserId);
  const { mutate: careGiverPutMutation } = useCareGiverPutMutation();

  const handleOnGiveAccessClick = (caregiverId) => {
    careGiverPutMutation({
      patientUserId: userQueryData?.patientUserId,
      caregiverUserId: caregiverId,
      isActive: true,
    });
  };

  const handleOnRevokeAccessClick = (caregiverId) => {
    careGiverPutMutation({
      patientUserId: userQueryData?.patientUserId,
      caregiverUserId: caregiverId,
      isActive: false,
    });
  };

  if (isFetching)
    return (
      <>
        <span>Loading...</span>
      </>
    );

  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Caregivers"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate('/user/hr/caregivers/add')}
        >
          Add
        </Button>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate('/user/hr/caregivers/invite')}
        >
          Invite
        </Button>
      </Flex>
      <Flex direction="column">
        <CareGiverViewTable
          careGiversData={data}
          onGiveAccessClick={handleOnGiveAccessClick}
          onRevokeAccessClick={handleOnRevokeAccessClick}
        />
      </Flex>
    </Flex>
  );
}
